import { render, staticRenderFns } from "./weekChangDialog.vue?vue&type=template&id=385c90e7&scoped=true"
import script from "./weekChangDialog.vue?vue&type=script&lang=js"
export * from "./weekChangDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385c90e7",
  null
  
)

export default component.exports